// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #root {
  min-height: 100vh;
} */

/* .App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
} */

input::placeholder {
  font-size: 15px;
  text-align: left;
  font-weight: 500;
}
textarea::placeholder {
  font-size: 15px;
  text-align: left;
  font-weight: 500;
}

/* .App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#side {
  height: 700px;
  width: 400px;
}

#logo {
  width: 250px;
  margin-left: 30%;
  margin-top: 2%;
}

#main {
  height: 700px;
}

.accountIcon {
  position: absolute;
  left: 605px;
  top: 277px;
}

.accountIcon2 {
  position: absolute;
  left: 605px;
  top: 360px;
}

.carousel-inner > a > img {
  margin-left: 5rem;
  width: 120px;
  height: 120px;
}

.slick-prev:before,
.slick-next:before {
  color: black;
  font-size: 48px;
}

#searchBox {
  background-image: url("../src/images/search.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 6px;
}

#showAll {
  width: 100%;
}

#filterItem {
  text-align: center;
}

#map {
  left: 65%;
}

#aboutHeader {
  position: relative;
}

#aboutHeader::before {
  content: "";
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-image: url(../src/images/aboutPageHeader.webp);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 55%;
  opacity: 0.5;
}

#about1 {
  background-image: url(../src/images/aboutPage1.webp);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 65%;
  height: 25rem;
}

#about2 {
  background-image: url(../src/images/aboutPage2.webp);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 65%;
  height: 25rem;
}

#about3 {
  background-image: url(../src/images/aboutPage3.webp);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 20%;
  height: 25rem;
}

section.pdf-body {
  padding: 16px;
  background-color: #eee;
  height: 100%;
  margin: 8px;
}

section.header-bar {
  padding: 16px;
  background-color: #eee;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

section.header-bar .header {
  font-size: 1.2em;
}

section.pdf-toolbar {
  padding: 16px;
}

section.pdf-toolbar button {
  background-color: #fff;
  border: 1px solid #555;
  padding: 8px;
  border-radius: 3px;
  cursor: pointer;
}

section.pdf-toolbar button:hover,
section.pdf-toolbar button:focus {
  border: 1px solid #333;
  background-color: #eee;
} */

/* For recaptcha v2 */
/* .captcha-error > * > * > *{
  border: 1px red solid;
} */

/* For react-pdf viewer responsive width */
.react-pdf__Page__canvas{
  width: 100% !important;
}


/*REACTTAGS STYLES START -----------------------------------------------------------------------------------------------------------------------------------------------------*/
.react-tags {
  position: relative;
  /* padding: 6px 0 0 6px; */
  padding: 10px 10px 5px;
  border: 1px solid #D1D1D1;
  background-color: #ffffff;
  border-radius: 6px;

  /* shared font styles */
  font-size: 1em;
  line-height: 1.2;

  /* clicking anywhere will focus the input */
  cursor: text;
}

.react-tags.is-active {
  border-color: #3b82f6;
  border-width: 2px;
}

.react-tags.is-disabled {
  opacity: 0.75;
  background-color: #eaeef2;
  /* Prevent any clicking on the component */
  pointer-events: none;
  cursor: not-allowed;
}

/* .react-tags.is-valid {
  border-color: #1fa774;
  box-shadow: 0 0 0 3px rgba(31, 167, 116, 0.25);
} */

.react-tags.is-invalid {
  border-color: #fd5956;
  box-shadow: 0 0 0 2px rgba(253, 86, 83, 0.25);
}

.react-tags__label {
  position: absolute;
  /* left: -10000px; */
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.react-tags__list {
  /* Do not use display: contents, it's too buggy */
  display: inline;
  padding: 0;
}

.react-tags__list-item {
  display: inline;
  list-style: none;
}

.react-tags__tag-name {
  color: #ffffff;
}

.react-tags__tag {
  box-sizing: border-box;
  margin: 0 0.25rem 0.25rem 0;
  padding: 0.375rem 0.5rem;
  border: 0px solid #d1d1d1;
  border-radius: 10px;
  outline: none;
  background: #1d4ed8;
  color: #1d4ed8;;
  @important background-color: #1d4ed8;

  /* match the font styles */
  font-size: inherit;
  line-height: inherit;
}

.react-tags__tag:hover {
  color: #2563eb;
  background-color: #2563eb;
}

.react-tags__tag::after {
  content: '✕';
  margin-left: 0.5rem;
  font-size: 0.875rem;
  color: #ffffff;
}

.react-tags__tag:not(:hover)::after {
  color: #ffffff;
}

.react-tags__combobox {
  display: inline-block;

  /* match tag layout */
  padding: 0.375rem 0.25rem;
  margin-bottom: 0.25rem;

  /* prevents autoresize overflowing the container */
  max-width: 100%;
}

.react-tags__combobox-input {
  /* prevent autoresize overflowing the container */
  max-width: 100%;

  /* remove styles and layout from this element */
  margin: 0;
  padding: 0;
  border: 0;
  outline: none !important;
  background: none;

  /* match the font styles */
  font-size: inherit;
  line-height: inherit;
}

.react-tags__combobox-input::placeholder {
  color: #7c7d86;
  opacity: 1;
}

.react-tags__listbox {
  position: absolute;
  z-index: 1;
  top: calc(100% + 5px);

  /* Negate the border width on the container */
  left: -2px;
  right: -2px;

  max-height: 12.5rem;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #afb8c1;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 10px 15px -4px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px;
}

.react-tags__listbox-no-options {
  padding: 0.375rem 0.5rem;
  font-style: italic;
}

.react-tags__listbox-option {
  padding: 0.375rem 0.5rem;
}

.react-tags__listbox-option:hover {
  cursor: pointer;
  background: #eaeef2;
}

.react-tags__listbox-option:not([aria-disabled='true']).is-active {
  background: #2563eb;
  color: #ffffff;
}

.react-tags__listbox-option[aria-disabled='true'] {
  color: #7c7d86;
  cursor: not-allowed;
  pointer-events: none;
}

.react-tags__listbox-option[aria-selected='true']::after {
  content: '✓';
  margin-left: 0.5rem;
}

.react-tags__listbox-option[aria-selected='true']:not(.is-active)::after {
  color: #2563eb;
}
/*REACTTAGS STYLES END -----------------------------------------------------------------------------------------------------------------------------------------------------*/

footer {
  .partner-logo {
    max-width: 200px;
    margin-top: 30px;
    background: #fff;
    padding: 10px 10px 15px;
    border-radius: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./assets/App.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;;;;;;;;;;;;;GAaG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgKG;;AAEH,qBAAqB;AACrB;;GAEG;;AAEH,0CAA0C;AAC1C;EACE,sBAAsB;AACxB;;;AAGA,+KAA+K;AAC/K;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EAEzB,yBAAyB;EACzB,kBAAkB;;EAElB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;;EAEhB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oCAAoC;;EAEpC,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;;EAErB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;;EAEtB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,eAAe;;EAEf,+CAA+C;EAC/C,SAAS;EACT,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,gBAAgB;;EAEhB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;;EAErB,6CAA6C;EAC7C,UAAU;EACV,WAAW;;EAEX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mFAAmF;AACrF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA,6KAA6K;;AAE7K;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF","sourcesContent":["/* #root {\n  min-height: 100vh;\n} */\n\n/* .App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n} */\n\ninput::placeholder {\n  font-size: 15px;\n  text-align: left;\n  font-weight: 500;\n}\ntextarea::placeholder {\n  font-size: 15px;\n  text-align: left;\n  font-weight: 500;\n}\n\n/* .App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#side {\n  height: 700px;\n  width: 400px;\n}\n\n#logo {\n  width: 250px;\n  margin-left: 30%;\n  margin-top: 2%;\n}\n\n#main {\n  height: 700px;\n}\n\n.accountIcon {\n  position: absolute;\n  left: 605px;\n  top: 277px;\n}\n\n.accountIcon2 {\n  position: absolute;\n  left: 605px;\n  top: 360px;\n}\n\n.carousel-inner > a > img {\n  margin-left: 5rem;\n  width: 120px;\n  height: 120px;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  color: black;\n  font-size: 48px;\n}\n\n#searchBox {\n  background-image: url(\"../src/images/search.svg\");\n  background-repeat: no-repeat;\n  background-position-y: center;\n  background-position-x: 6px;\n}\n\n#showAll {\n  width: 100%;\n}\n\n#filterItem {\n  text-align: center;\n}\n\n#map {\n  left: 65%;\n}\n\n#aboutHeader {\n  position: relative;\n}\n\n#aboutHeader::before {\n  content: \"\";\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background-image: url(../src/images/aboutPageHeader.webp);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 55%;\n  opacity: 0.5;\n}\n\n#about1 {\n  background-image: url(../src/images/aboutPage1.webp);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 65%;\n  height: 25rem;\n}\n\n#about2 {\n  background-image: url(../src/images/aboutPage2.webp);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 65%;\n  height: 25rem;\n}\n\n#about3 {\n  background-image: url(../src/images/aboutPage3.webp);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 20%;\n  height: 25rem;\n}\n\nsection.pdf-body {\n  padding: 16px;\n  background-color: #eee;\n  height: 100%;\n  margin: 8px;\n}\n\nsection.header-bar {\n  padding: 16px;\n  background-color: #eee;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\nsection.header-bar .header {\n  font-size: 1.2em;\n}\n\nsection.pdf-toolbar {\n  padding: 16px;\n}\n\nsection.pdf-toolbar button {\n  background-color: #fff;\n  border: 1px solid #555;\n  padding: 8px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\nsection.pdf-toolbar button:hover,\nsection.pdf-toolbar button:focus {\n  border: 1px solid #333;\n  background-color: #eee;\n} */\n\n/* For recaptcha v2 */\n/* .captcha-error > * > * > *{\n  border: 1px red solid;\n} */\n\n/* For react-pdf viewer responsive width */\n.react-pdf__Page__canvas{\n  width: 100% !important;\n}\n\n\n/*REACTTAGS STYLES START -----------------------------------------------------------------------------------------------------------------------------------------------------*/\n.react-tags {\n  position: relative;\n  /* padding: 6px 0 0 6px; */\n  padding: 10px 10px 5px;\n  border: 1px solid #D1D1D1;\n  border-radius: 1px;\n  background-color: #ffffff;\n  border-radius: 6px;\n\n  /* shared font styles */\n  font-size: 1em;\n  line-height: 1.2;\n\n  /* clicking anywhere will focus the input */\n  cursor: text;\n}\n\n.react-tags.is-active {\n  border-color: #3b82f6;\n  border-width: 2px;\n}\n\n.react-tags.is-disabled {\n  opacity: 0.75;\n  background-color: #eaeef2;\n  /* Prevent any clicking on the component */\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n/* .react-tags.is-valid {\n  border-color: #1fa774;\n  box-shadow: 0 0 0 3px rgba(31, 167, 116, 0.25);\n} */\n\n.react-tags.is-invalid {\n  border-color: #fd5956;\n  box-shadow: 0 0 0 2px rgba(253, 86, 83, 0.25);\n}\n\n.react-tags__label {\n  position: absolute;\n  /* left: -10000px; */\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.react-tags__list {\n  /* Do not use display: contents, it's too buggy */\n  display: inline;\n  padding: 0;\n}\n\n.react-tags__list-item {\n  display: inline;\n  list-style: none;\n}\n\n.react-tags__tag-name {\n  color: #ffffff;\n}\n\n.react-tags__tag {\n  box-sizing: border-box;\n  margin: 0 0.25rem 0.25rem 0;\n  padding: 0.375rem 0.5rem;\n  border: 0px solid #d1d1d1;\n  border-radius: 10px;\n  outline: none;\n  background: #1d4ed8;\n  color: #1d4ed8;;\n  @important background-color: #1d4ed8;\n\n  /* match the font styles */\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.react-tags__tag:hover {\n  color: #2563eb;\n  background-color: #2563eb;\n}\n\n.react-tags__tag::after {\n  content: '✕';\n  margin-left: 0.5rem;\n  font-size: 0.875rem;\n  color: #ffffff;\n}\n\n.react-tags__tag:not(:hover)::after {\n  color: #ffffff;\n}\n\n.react-tags__combobox {\n  display: inline-block;\n\n  /* match tag layout */\n  padding: 0.375rem 0.25rem;\n  margin-bottom: 0.25rem;\n\n  /* prevents autoresize overflowing the container */\n  max-width: 100%;\n}\n\n.react-tags__combobox-input {\n  /* prevent autoresize overflowing the container */\n  max-width: 100%;\n\n  /* remove styles and layout from this element */\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: none !important;\n  background: none;\n\n  /* match the font styles */\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.react-tags__combobox-input::placeholder {\n  color: #7c7d86;\n  opacity: 1;\n}\n\n.react-tags__listbox {\n  position: absolute;\n  z-index: 1;\n  top: calc(100% + 5px);\n\n  /* Negate the border width on the container */\n  left: -2px;\n  right: -2px;\n\n  max-height: 12.5rem;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 1px solid #afb8c1;\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 10px 15px -4px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px;\n}\n\n.react-tags__listbox-no-options {\n  padding: 0.375rem 0.5rem;\n  font-style: italic;\n}\n\n.react-tags__listbox-option {\n  padding: 0.375rem 0.5rem;\n}\n\n.react-tags__listbox-option:hover {\n  cursor: pointer;\n  background: #eaeef2;\n}\n\n.react-tags__listbox-option:not([aria-disabled='true']).is-active {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.react-tags__listbox-option[aria-disabled='true'] {\n  color: #7c7d86;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.react-tags__listbox-option[aria-selected='true']::after {\n  content: '✓';\n  margin-left: 0.5rem;\n}\n\n.react-tags__listbox-option[aria-selected='true']:not(.is-active)::after {\n  color: #2563eb;\n}\n/*REACTTAGS STYLES END -----------------------------------------------------------------------------------------------------------------------------------------------------*/\n\nfooter {\n  .partner-logo {\n    max-width: 200px;\n    margin-top: 30px;\n    background: #fff;\n    padding: 10px 10px 15px;\n    border-radius: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
